import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFieldTelusBusinessInternetBackup } from './telusBusinessInternetBackupFieldName';

export const getTelusBusinessInternetTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    pricingFieldTelusBusinessInternetBackup,
    formFields,
    orderData
  );
  return customerInformationTotals;
};

export const getTelusBusinessInternetTotalsSelection = formFields => {
  const selectionsList = priceSelectionList(
    pricingFieldTelusBusinessInternetBackup,
    formFields
  );
  return selectionsList;
};
